import { useEffect } from "react";

export function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} · KREONIS` : "KREONIS — Understand Markets. Find Signals. Manage Risk.";
    const setMeta = (name, content, prop) => {
      if (!content) return;
      const sel = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let el = document.querySelector(sel);
      if (!el) { el = document.createElement("meta"); el.setAttribute(prop ? "property" : "name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const desc = description || "AI-powered market intelligence, probabilistic trading signals, paper trading, backtesting and risk management.";
    setMeta("description", desc);
    setMeta("og:title", title ? `${title} · KREONIS` : "KREONIS", true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "website", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title || "KREONIS");
    setMeta("twitter:description", desc);
  }, [title, description]);
  return null;
}
